<script>
	export let conditions;
	let algorithms = [
		{ value: "random", label: "Random (default)" },
		{ value: "attitude_filter_feed", label: "Attitude filter feed" },
		{
			value: "will_smith_priority_treatment",
			label: "Will-Smith treatment",
		},
		{
			value: "thompson_sampling",
			label: "Thompson sampling (coming soon!)",
		},
		{ value: "engagement", label: "Engagement (coming soon!)" },
		{ value: "preference", label: "Preference (coming soon!)" },
	];
	let inputDefaultValue = "random";
	let algorithmParams = [];

	const getStorage = (conditions) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.algorithmParams) {
				algorithmParams = params["algorithmParams"];
			}
		} else {
			params = {};
		}
		// if no algorithm parameters in localStorage yet, create and populate it with default value
		if (!algorithmParams) {
			algorithmParams = [];
			for (let i = 0; i < conditions; i++) {
				algorithmParams.push(inputDefaultValue);
			}
		} else {
			// if algorithm parameters in localStorage, check if it has the right number of conditions
			if (algorithmParams.length < conditions) {
				// if not, add the missing conditions
				for (let i = algorithmParams.length; i < conditions; i++) {
					algorithmParams.push(inputDefaultValue);
				}
			}
		}
		params["algorithmParams"] = algorithmParams;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["algorithmParams"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(algorithmParams);

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: parameters[i],
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, algorithmParams, "algorithm");
</script>

<hr />
<h3>News feed algorithm</h3>
<p style="font-size:0.9em;">
	<em
		>For all non-default options, <strong>all cards</strong> will be
		selected from each entity set (overwrites values indicated in the above
		<strong>Cards</strong>
		section).
	</em>
</p>

{#each { length: conditions } as _, ii}
	<p><strong>Condition {ii + 1}</strong></p>
	<div>
		<label for={"condition-" + (ii + 1) + ";algorithm"} />
		<select
			name={"condition-" + (ii + 1) + ";algorithm"}
			bind:value={algorithmParams[ii]}
		>
			{#each algorithms as algorithm}
				<option value={algorithm.value}>{algorithm.label}</option>
			{/each}
		</select>
	</div>
{/each}

<style>
	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}
</style>
